module.exports = __webpack_public_path__ + "img/logo0930.0f239323.svg";